import { EnumMaterialFlow } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

export const getEnumMaterialFlowLabel = (value: EnumMaterialFlow) => {
    switch (value) {
        case EnumMaterialFlow.Incoming:
            return 'Eingang';
        case EnumMaterialFlow.Outgoing:
            return 'Ausgang';
        case EnumMaterialFlow.Transport:
            return 'Strecke';
        case EnumMaterialFlow.ForeignWeighing:
            return 'Fremdverwiegung';
        case EnumMaterialFlow.Empty:
            return 'Leer';
        case EnumMaterialFlow.Control:
            return 'Kontrollverwiegung';
        case EnumMaterialFlow.Trade:
            return 'Handel';
        case EnumMaterialFlow.Purchase:
            return 'Einkauf';
        case EnumMaterialFlow.Sale:
            return 'Verkauf';
        default:
            return 'Nicht definiert';
    }
};

export const materialFlowOptions: SelectOption<EnumMaterialFlow>[] = [
    { name: 'incoming', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Incoming), value: EnumMaterialFlow.Incoming },
    { name: 'outgoing', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Outgoing), value: EnumMaterialFlow.Outgoing },
    {
        name: 'transport',
        label: getEnumMaterialFlowLabel(EnumMaterialFlow.Transport),
        value: EnumMaterialFlow.Transport,
    },
    {
        name: 'foreignWeighing',
        label: getEnumMaterialFlowLabel(EnumMaterialFlow.ForeignWeighing),
        value: EnumMaterialFlow.ForeignWeighing,
    },
    { name: 'control', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Control), value: EnumMaterialFlow.Control },
    { name: 'trade', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Trade), value: EnumMaterialFlow.Trade },
    { name: 'purchase', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Purchase), value: EnumMaterialFlow.Purchase },
    { name: 'sale', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Sale), value: EnumMaterialFlow.Sale },
    { name: 'empty', label: getEnumMaterialFlowLabel(EnumMaterialFlow.Empty), value: EnumMaterialFlow.Empty },
];
